export default "__VITE_ASSET__DyOUmskV__"